export default "/_next/static/data/striking-the-balance-lottie.json-d71b8a3ea72caa39dd2cbf73c94f243a.json";